module.exports = __webpack_public_path__ + "static/img/voice2.4fc9d7d0.png";